
import { City } from "@/models/City";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import LanguageSelectCard from "../Base/LanguageSelectCard.vue";
import CityGeneral from "./CityTabs/CityGeneral.vue";
import CityLocation from "./CityTabs/CityLocation.vue";
import SavePanel from "../Base/SavePanel.vue";
import AddLocation from "./AddLocation.vue";
import { cloneDeep, isEqual } from "lodash";
import DateHelper from "@/utils/DateHelper";

@Component({
  components: {
    LanguageSelectCard,
    CityGeneral,
    CityLocation,
    AddLocation,
    SavePanel,
  },
})
class ViewCity extends Vue {
  cityDataObject = {} as City;
  setLocation = false;
  setCityDetails = true;
  locationSlug = "";
  showSavePanel = false;
  isSavedOrDiscard = false;
  isEditingLocked = true;
  closeLocation = false;
  tabPicked = 0;

  get showButton(): boolean {
    if (this.tabPicked == 0) {
      return false;
    } else {
      return true;
    }
  }

  get getCityData(): City {
    return this.$store.state.cityStore.singleCity;
  }

  get getCityDataObject(): City {
    return this.cityDataObject;
  }

  handleSubmitPressed(): void {
    this.closeLocation = true;
  }
  discardChanges(value: boolean): void {
    this.cityDataObject = cloneDeep(this.getCityData);
    this.showSavePanel = false;
    if (value) {
      this.$store.dispatch("cityStore/addEditLock", {
        slug: this.getCityData.slug,
        value: false,
      });
      this.isEditingLocked = true;
      this.$emit("selectableTable", true);
    } else {
      this.isSavedOrDiscard = true;
      this.$store.dispatch("cityStore/addEditLock", {
        slug: this.getCityData.slug,
        value: true,
      });
    }
  }

  created(): void {
    this.cityDataObject = cloneDeep(this.getCityData);
    this.isEditingLocked = true;
    this.$store.commit("cityStore/currentlyEditing", false);
    this.$emit("selectableTable", true);
    window.addEventListener("beforeunload", this.confirm_leaving);
  }
  @Watch("getCityData", { deep: true })
  async onPropertyChanged(): Promise<void> {
    this.cityDataObject = cloneDeep(this.getCityData);
  }
  updateTempObject(data: any): void {
    this.cityDataObject = cloneDeep(data.cityData);
    this.isSavedOrDiscard = false;
    if (!isEqual(this.getCityData, this.cityDataObject)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
  }
  async saveChanges(value: boolean): Promise<void> {
    this.cityDataObject.is_edit = !value;
    if (this.cityDataObject.locations["centre_point"] === undefined) {
      this.cityDataObject.locations["centre_point"] = {
        slug: "centre_point",
        name: { en: "centre_point" },
        lat_long: {
          latitude: this.cityDataObject.centre_point.latitude,
          longitude: this.cityDataObject.centre_point.longitude,
        },
      };
    }
    const place = await this.getCountryFromLatLng(
      this.cityDataObject.centre_point.latitude,
      this.cityDataObject.centre_point.longitude
    );
    this.cityDataObject.country = this.getCountry(place);
    this.$store.dispatch("cityStore/updateCity", this.cityDataObject);
    this.showSavePanel = false;
    if (value) {
      this.isEditingLocked = true;
      this.$store.commit("cityStore/currentlyEditing", false);
      this.$emit("selectableTable", true);
    } else {
      this.isSavedOrDiscard = true;
    }
  }
  closeTabs(): void {
    this.$emit("closeTabs");
  }

  openLocation(value: string): void {
    this.setLocation = true;
    this.setCityDetails = false;
    this.locationSlug = value;
  }

  setMapSelectable(): void {
    this.setLocation = false;
    this.setCityDetails = true;
    this.locationSlug = "";
  }
  handleUnlock(): void {
    this.$store.dispatch("cityStore/addEditLock", {
      slug: this.getCityData.slug,
      value: true,
    });
    this.isEditingLocked = false;
    this.$emit("selectableTable", false);
  }
  handlelock(): void {
    this.discardChanges(true);
  }
  getTabs(event: any): void {
    this.tabPicked = event;
  }

  confirm_leaving(evt: any) {
    if (!this.isEditingLocked) {
      const unsaved_changes_warning =
        "You are currently in edit mode and potentially have unsaved changes. Proceeding will discard all changes. There is no undo. Are you sure?";
      evt.returnValue = unsaved_changes_warning;
      return unsaved_changes_warning;
    }
  }

  getCountry(place: any): string {
    try {
      for (var i = 0; i < place.results[0].address_components.length; i++) {
        if (
          place.results[0].address_components[i].types.indexOf("country") != -1
        ) {
          return place.results[0].address_components[i].short_name;
        }
      }
      return "";
    } catch (error) {
      console.log(error);
      return "";
    }
  }

  closeDialog(): void {
    this.closeLocation = false;
  }

  async getCountryFromLatLng(lat: number, long: number): Promise<any> {
    const data = await DateHelper.getCountry(lat, long);
    return data;
  }
}

export default ViewCity;
